<div class="d-lg-flex d-none table-header fw-bold py-2 mb-3">
    <div class="col-md-1 col-2 limited-col-width"></div>
    <label class="col-1" translate="CONFIRMATION_MATERIAL_HEADER_MATNO"></label
    ><label class="col-2" translate="CONFIRMATION_MATERIAL_HEADER_PO"></label>
    <label class="col-3" translate="CONFIRMATION_MATERIAL_HEADER_DESC"></label>
    <label class="col-2" translate="CONFIRMATION_MATERIAL_HEADER_QUANTITY"></label>
    <label class="col-1" translate="CONFIRMATION_MATERIAL_HEADER_UNIT"></label>
    <div class="col-md-2"></div>
</div>

<div [formGroup]="confirmationMaterialForm">
    @for (
        material of model.listMaterial.value;
        track material.materialIdentifier.toString();
        let i = $index;
        let lastElement = $last
    ) {
        <fieldset class="mb-3">
            <pace-material-consumption-row
                [parentForm]="confirmationMaterialFormChildren"
                [model]="model"
                [material]="material"
                [index]="i"
                (materialUpdatedFromPickup)="updateListMaterial($event)"
                (materialRemoved)="onMaterialRemoved($event)"
                [lastElement]="lastElement"
                [isInvitro]="isInvitro"
            >
            </pace-material-consumption-row>
        </fieldset>
    }
</div>

@if (displayAddMaterialButton || isInvitro) {
    <div class="d-flex flex-wrap">
        <label class="col-sm-3 col-12 col-form-label text-start" translate="CONFIRMATION_MATERIAL_ADDMATERIAL"></label>
        <div class="d-flex flex-row col-sm-9 col-12 gap-1 gap-md-2 gap-lg-3">
            @if (displayAddMaterialButton) {
                <button
                    type="button"
                    class="btn btn-primary"
                    translate="CONFIRMATION_MATERIAL_LABEL_ADDMATERIAL"
                    (click)="openAddMaterialUI()"
                ></button>
            }
            @if (isInvitro) {
                <button
                    type="button"
                    class="btn btn-secondary"
                    translate="CONFIRMATION_MATERIAL_ADDITIONAL_MATERIAL"
                    (click)="openMaterialStock()"
                ></button>
            }
        </div>
    </div>
}
